export enum ProductItemStatus {
    InStock,
    HandedOut
}